<template>
  <ModalWrapper :model-name="modelName">
    <div class="rules-modal">
      <div class="rules-modal-head">
        <p class="rules-modal-head_title">
          Important Rules & Guidelines
        </p>
      </div>
      <div class="rules-modal_body">
        <ul class="rules-modal_list">
          <li class="rules-modal_list-item">
            <p class="rules-modal_list-item-icon">
              <img src="@/assets/icons/adoult.svg" alt="rules" />
            </p>
            <p class="rules-modal_list-item-text">
              you must be 18+ to use this website
            </p>
          </li>
          <li class="rules-modal_list-item">
            <p class="rules-modal_list-item-icon">
              <img src="@/assets/icons/stop.svg" alt="rules" />
            </p>
            <p class="rules-modal_list-item-text">
              You can’t use other people’s photos without their permission
            </p>
          </li>
          <li class="rules-modal_list-item">
            <p class="rules-modal_list-item-icon">
              <img src="@/assets/icons/salute.svg" alt="rules" />
            </p>
            <p class="rules-modal_list-item-text">
              you are solely responsible for the image you generated
            </p>
          </li>
        </ul>

        <p class="rules-modal_info">
          {{ $t('rules.accept') }}
          <br />
          <a :href="`/${locale}/terms`" target="_blank">{{ $t('footer.links.link4') }}</a>,
          <a :href="`/${locale}/policy`" target="_blank">{{ $t('footer.links.link2') }}</a> &
          <a :href="`/${locale}/privacy`" target="_blank">{{ $t('footer.links.link3') }}</a>
        </p>
      </div>
      <div class="rules-modal_footer">
        <button
          @click="onClose"
          class="rules-modal_button"
        >
          I agree
        </button>
      </div>
    </div>
  </ModalWrapper>
</template>

<script>
import ModalWrapper from "@/components/modals/ModalWrapper.vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { setCookie } from "@/utils/cookies";

export default {
  name: "RulesModal",
  components: {
    ModalWrapper,
  },
  props: {
    modelName: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const { locale } = useI18n()

    const onClose = () => {
      setCookie('rules-accepted', 'true');

      store.commit("removeAllModal");
      emit("closeModal");
    };

    return {
      locale,
      onClose,
    };
  },
};
</script>

<style lang="scss" scoped>
.rules-modal {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  margin: 0 auto;
  padding: 20px;
  max-width: 400px;
  width: 95%;
  overflow: auto;
  border-radius: 30px;
  border: 2px solid #ACF601;
  background: #2C2B2B;
  max-height: 90vh;
  @media screen and (max-width: 1024px) {
    padding: 25px;
  }
  &:before {
    content: '';
    position: absolute;
    z-index: -1;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .9);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &-head {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 25px;
    &_title {
      font-weight: 700;
      font-size: 22px;
      text-transform: capitalize;
    }
    &_close {
      cursor: pointer;
    }
  }
  &_body {
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 25px;
  }

  &_list {
    display: flex;
    flex-direction: column;
    gap: 20px;
    list-style: none;

    &-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 20px;
      border-radius: 20px;
      border: 2px solid #ACF601;
      background: #141313;
      padding: 15px;

      &-icon {
        img {
          width: 30px;
          height: 30px;
        }
      }

      &-text {
        font-size: 18px;
        line-height: 100%;
        color: #FFF;
        font-style: normal;
        font-weight: 500;
        text-transform: capitalize;
      }
    }
  }

  &_info {
    color: #FFF;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    text-transform: capitalize;

    a {
      color: #ACF601;
      text-decoration: underline;
    }

    @media screen and (max-width: 550px) {
      font-size: 14px;
    }
  }

  &_footer {
    padding-top: 10px;
    display: flex;
    justify-content: center;
  }

  &_button {
    border: none;
    cursor: pointer;
    width: 100%;
    box-shadow: 1px 2px 10px #67eb00;
    outline: none;
    transition: all 0.3s;
    border-radius: 20px;
    background: #ACF601;
    height: 50px;
    color: #000;
    text-align: center;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    text-transform: capitalize;
    &:hover {
      box-shadow: 1px 2px 25px #67eb00;
      color: rgba(0, 0, 0, 1);
    }
    &--disabled {
      opacity: 0.55;
      cursor: not-allowed;
    }

    @media screen and (max-width: 1024px) {
      font-size: 20px;
      height: 50px;
      border-radius: 10px;
    }

    @media screen and (max-width: 768px) {
      font-size: 16px;
      height: 40px;
      border-radius: 8px;
    }

    @media screen and (max-width: 650px) {
      width: 100%;
    }
  }
}
</style>
